// THE WINDOW'S WIDTH — remembered per PERSON (Nika 2026-09-29: "why did you
// decrease width of pageslot? maybe increase a bit so at least it takes up to
// 60-70% and add option to resize in full").
//
//   el.call('setSlotSheetWidth', 72)    // a percent of the band
//   el.call('setSlotSheetWidth', null)  // back to the default
//
// The PageSlot sheet's resize handle (canvas/components/PageSlot.js, the width
// block) writes the share of the band one floating window takes. The share
// lives on the person's user_preferences row as `slotSheetWidth` — the same
// share on every screen and every device — with this session's decision on
// `root._slotSheetWidth` (the window answers at once, even before the row has
// loaded) and this device's copy in localStorage (`symbols_slot_sheet_w`: it
// paints before the row arrives; the record wins once it has). null clears
// all three to the default, so a changed default reaches this person too.
//
// WRITES ARE DECISIONS (the home-prefs durability law; functions/homeLook.js
// states the whole contract this repeats): at once, never debounced,
// SINGLE-FLIGHT on the queue every writer of the row shares
// (`root.__navbarSaveQueue`, keyed by workspace). The update REPLACES the row,
// so the payload is a MERGE onto a FRESH read at send time; no partial copy of
// an unloaded row ever lands in the state; a read that fails sends nothing; a
// decision superseded while it waited sends nothing.
//
// Frank note: every registered export is serialized on its own (FA204), so
// this one is self-contained — the bounds restate PageSlot.js's.
export function setSlotSheetWidth(pct) {
  let value = null
  if (pct != null) {
    const n = Number(pct)
    if (!isFinite(n) || typeof pct === 'boolean') {
      console.warn(
        `[shell] setSlotSheetWidth ignored "${String(pct)}" — a percent of the band (30-100) or null`
      )
      return null
    }
    value = Math.round(Math.max(30, Math.min(100, n)) * 10) / 10
  }
  const self = this && typeof this === 'object' ? this : null
  const root = (self && self.state && self.state.root) || null
  if (!root || typeof root.update !== 'function') return null
  const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null
  const patch = { _slotSheetWidth: value }
  if (prefs) patch.userPrefs = { ...prefs, slotSheetWidth: value }
  root.update(patch, { preventFetch: true })
  try {
    if (typeof localStorage !== 'undefined') {
      if (value == null) localStorage.removeItem('symbols_slot_sheet_w')
      else localStorage.setItem('symbols_slot_sheet_w', String(value))
    }
  } catch (err) {
    console.warn('[shell] slot sheet width cache write failed:', err && err.message)
  }
  const sdk = (self && (self.sdk || (self.context && self.context.sdk))) || null
  if (!sdk || typeof sdk.execute !== 'function') return null
  const w = root.workspace
  const key =
    String(
      (w && (w.id || w._id)) || (root.jwtClaims && root.jwtClaims.active_workspace_id) || ''
    ) || 'user'
  if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map()
  const queue = root.__navbarSaveQueue
  root.__slotSheetWidthSeq = (root.__slotSheetWidthSeq || 0) + 1
  const seq = root.__slotSheetWidthSeq
  const prior = queue.get(key) || Promise.resolve()
  const task = prior
    .catch(() => {})
    .then(async () => {
      if (seq !== root.__slotSheetWidthSeq) return null
      // PER-PATH PATCH — names only `slotSheetWidth`; `null` CLEARS the key
      // (unset), never stored as a literal null (CORE-USERPREFS-PATCH-PER-PATH-1).
      const row = await sdk.execute(
        'workspaceProject.userPreferences',
        'patch',
        value === null
          ? { patch: { unset: ['slotSheetWidth'] } }
          : { patch: { set: { slotSheetWidth: value } } }
      )
      if (seq === root.__slotSheetWidthSeq) {
        const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null
        root.update(
          {
            userPrefs: now
              ? { ...now, slotSheetWidth: value }
              : row && typeof row === 'object'
                ? row
                : { slotSheetWidth: value }
          },
          { preventFetch: true }
        )
      }
      return row
    })
  queue.set(key, task)
  return task.catch((err) => {
    console.warn('[shell] user_preferences slotSheetWidth save failed:', err && err.message)
    return null
  })
}
